var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0117 7.65343C33.3901 7.65343 25.4915 0.738962 25.4133 0.669692C24.8883 0.203853 24.0881 0.203853 23.5632 0.669692C23.4846 0.739501 15.6068 7.65343 7.96484 7.65343C7.2044 7.65343 6.58789 8.25682 6.58789 9.00108V25.1404C6.58789 38.2149 16.5236 43.4393 23.9972 46.2317C24.1553 46.2908 24.3218 46.3203 24.4883 46.3203C24.6548 46.3203 24.8212 46.2907 24.9794 46.2317C32.4529 43.4393 42.3887 38.2148 42.3887 25.1404V9.00108C42.3887 8.25682 41.7722 7.65343 41.0117 7.65343ZM39.6348 25.1404C39.6348 36.1711 31.6483 40.7851 24.4883 43.5279C17.3283 40.7851 9.3418 36.1711 9.3418 25.1404V10.2885C15.9724 9.72091 22.1897 5.26394 24.4883 3.4349C26.7869 5.26385 33.0042 9.72082 39.6348 10.2885V25.1404Z",
    fill: "url(#paint0_linear_201_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4895 23.7251C27.4895 23.7251 29.9418 21.2727 29.9418 18.2727C29.9418 15.2727 27.4895 12.8203 24.4895 12.8203C21.4894 12.8203 19.0371 15.2727 19.0371 18.2727C19.0371 21.2727 21.4895 23.7251 24.4895 23.7251Z",
    fill: "url(#paint1_linear_201_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8472 28.0804C33.7043 27.7232 33.5139 27.3899 33.2996 27.0804C32.2044 25.4613 30.5139 24.3899 28.6092 24.128C28.3711 24.1042 28.1092 24.1518 27.9187 24.2946C26.9187 25.0327 25.7282 25.4137 24.4901 25.4137C23.252 25.4137 22.0615 25.0327 21.0615 24.2946C20.871 24.1518 20.6091 24.0804 20.371 24.128C18.4663 24.3899 16.752 25.4613 15.6806 27.0804C15.4663 27.3899 15.2758 27.7471 15.133 28.0804C15.0616 28.2233 15.0853 28.3899 15.1568 28.5328C15.3473 28.8661 15.5853 29.1995 15.7996 29.4852C16.1329 29.9376 16.4901 30.3423 16.8949 30.7232C17.2282 31.0566 17.6091 31.3661 17.9901 31.6756C19.871 33.0804 22.133 33.8185 24.4663 33.8185C26.7996 33.8185 29.0616 33.0804 30.9425 31.6756C31.3234 31.3899 31.7044 31.0566 32.0377 30.7232C32.4187 30.3423 32.7996 29.9375 33.133 29.4852C33.3711 29.1756 33.5854 28.8661 33.7758 28.5328C33.8948 28.3899 33.9186 28.2232 33.8472 28.0804Z",
    fill: "url(#paint2_linear_201_421)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_421",
    x1: -3.6238,
    y1: 10.1994,
    x2: 42.578,
    y2: 46.1573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52FFF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_421",
    x1: 15.9267,
    y1: 15.1623,
    x2: 27.2252,
    y2: 26.4607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52FFF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_421",
    x1: 9.7281,
    y1: 26.1976,
    x2: 17.9262,
    y2: 42.0762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52FFF0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    fill: "white",
    transform: "translate(0.988281 0.320312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.c68c3b65a69f3ce946df60bda3922cc0.svg";
export { ForwardRef as ReactComponent };